import _baseCreate_default from "./_baseCreate.js";
import _isPrototype_default from "./_isPrototype.js";
import _getPrototype_default from "./_getPrototype.js";

//#region ../../node_modules/lodash-es/_initCloneObject.js
/**
* Initializes an object clone.
*
* @private
* @param {Object} object The object to clone.
* @returns {Object} Returns the initialized clone.
*/
function initCloneObject(object) {
	return typeof object.constructor == "function" && !_isPrototype_default(object) ? _baseCreate_default(_getPrototype_default(object)) : {};
}
var _initCloneObject_default = initCloneObject;

//#endregion
export { _initCloneObject_default as default };
//# sourceMappingURL=_initCloneObject.js.map